export const SET = 'player_set';
export const UNSET = 'player_unset';
export const SET_BALANCE = 'player_set_balance';
export const SET_PASSWORDS = 'player_set_passwords';
export const UPDATE_STATE = 'player_update_state';
export const SET_WINNING_JACKPOT = 'player_set_winningJackpot';
export const SHOW_WON_JACKPOT = 'player_showWonJackpot';


// WEBPACK FOOTER //
// ./_common/data/player/mutation-types.js